// extracted by mini-css-extract-plugin
export var caption = "bH_gP";
export var grey = "bH_dq";
export var heading = "bH_G";
export var image = "bH_k";
export var left = "bH_bL";
export var reverse = "bH_dm";
export var right = "bH_bQ";
export var section = "bH_j";
export var video = "bH_gC";
export var videoContainer = "bH_ch";
export var videoWrapper = "bH_cj";